import { render, staticRenderFns } from "./AdminPanelDashboardDialogDelete.vue?vue&type=template&id=47ef34d2"
import script from "./AdminPanelDashboardDialogDelete.vue?vue&type=script&lang=js"
export * from "./AdminPanelDashboardDialogDelete.vue?vue&type=script&lang=js"
import style0 from "./AdminPanelDashboardDialogDelete.vue?vue&type=style&index=0&id=47ef34d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports